import { useEffect, useState } from 'react'
import dashedLine from '../images/dashed-curved-search-line-mobile.svg'
import { select } from 'd3'
import { noop } from 'lodash'
import { TextField, TextFieldProps, styled } from '@mui/material'

const CustomTextField = styled((props: TextFieldProps) => (
  <TextField {...props} />
))(() => ({
  '& .MuiOutlinedInput-root': {
    border: '1px solid #e9e7e1',
    backgroundColor: 'transparent',
    color: '#e9e7e1',
  },
  '&.Mui-focused': {
    border: '1px solid #e9e7e1',
    outline: 'none',
  },
}))

type MobileScreen6Props = {
  anchorRef: React.RefObject<HTMLDivElement>
}

const MobileScreen6 = ({ anchorRef }: MobileScreen6Props) => {
  const [x, setX] = useState(0)
  const [y, setY] = useState(0)
  useEffect(() => {
    const currentRef = anchorRef.current
    if (currentRef) {
      const { x: xCoord, y: yCoord } = anchorRef.current.getBoundingClientRect()
      setX(xCoord)
      setY(yCoord)
      select(currentRef).style('visibility', 'hide')
    }
    return () => {
      select(currentRef).style('visibility', 'show')
    }
  }, [anchorRef])
  return (
    <div className="flex p-16 h-full bg-[#222222] bg-opacity-[.78] w-screen relative">
      <div
        className="opacity-1 absolute z-[10000]"
        style={{
          left: `${x}px`,
          top: `${y}px`,
        }}
      >
        <CustomTextField
          className="w-[331px] text-white"
          placeholder="Search by Keyword..."
          variant="outlined"
          value=""
          onChange={noop}
        />
      </div>
      <div
        className="flex flex-col items-center gap-1 w-[245px] opacity-1 absolute"
        style={{
          left: `${x}px`,
          top: `${y + 70}px`,
        }}
      >
        <img src={dashedLine} alt="dashed line" />
        <p className="text-orange font-decimal text-[22px]">
          Search by organization name or any keyword to filter the table
        </p>
      </div>
    </div>
  )
}
export default MobileScreen6
